import Category from '@/models/Category';

export enum OnboardTypes {
    COMPLETE_ONBOARD_REQUEST = '@onboard/COMPLETE_ONBOARD_REQUEST',
    COMPLETE_ONBOARD_SUCCESS = '@onboard/COMPLETE_ONBOARD_SUCCESS',
    COMPLETE_ONBOARD_FAILURE = '@onboard/COMPLETE_ONBOARD_FAILURE',
}

export interface OnboardState {
    data: {
        categories: Category[];
    };
    loading: boolean;
    hasError: boolean;
}
